











import Vue from 'vue';
import TextLine from './textsection/TextLine.vue';

export default Vue.extend({
  name: `TextSection`,
  components: { TextLine },
  props: {
    text: {
      required: true,
      type: Array as () => string[],
    },
    underlined: {
      default: false,
      type: Boolean,
    },
    uppercase: {
      default: false,
      type: Boolean,
    },
  },
});
